import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Even good blogs need help",
  "description": "",
  "published": "2008-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/even-good-blogs-need-help/swizec/48"],
  "categories": "intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Blogging has a very big problem over all, and it's not the fact that most blogs out there simply suck, it's that there are many great blogs out there, but because the people making them aren't marketing geniuses they get lost in the sea of blogs. This is a problem writers used to have, so they invented managers, it's a problem open source software had, so we invented OSS list sites that help spread the word of good software.`}</p>
    <p>{`Neither of these approaches will work very well for blogs. Managers are out of the question since blogging doesn't really make that much money and we don't want to pollute it with such mumbo jumbo anyway. Sites with lists upon lists of blogs won't work either since they're far too satured. So `}<a parentName="p" {...{
        "href": "http://chuckwestbrook.com/"
      }}>{`Chuck Westbrook`}</a>{` had an awesome idea and I'm biting. In a blogpost entitled `}<a parentName="p" {...{
        "href": "http://chuckwestbrook.com/great-content-no-readers/"
      }}>{`How you can help end the problem of blogs with great content and no readers`}</a>{` he proposed a sort of reading group for blogs. We sign up for the idea, read a different blog every two weeks and if we like it ... I guess we're supposed to do what we do with all the stuff we like. Talk about it.`}</p>
    <p>{`Anything to find new blogs, let's do this.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      